<script setup>
import {ref, inject} from "vue";
import {getNoun, getNumberWithNoun} from "@/helpers/string";
import MatchMakingModal from "@/views/needs/need/matchMaking/MatchMakingModal.vue";
import {getEcoLogo} from "@/helpers/logo";

const need = inject('need');
const getInfo = inject('getInfo');

const aiMatchMakingModal = ref(null);
const ecoMatchMakingModal = ref(null);

function evaluate(type) {
    if (type === 'ai') {
        aiMatchMakingModal.value.open()
    }

    if (type === 'eco') {
        ecoMatchMakingModal.value.open()
    }
}

defineExpose({
    evaluate,
});
</script>

<template>
    <div v-if="need.recommended_startups_ai_count || need.recommended_startups_eco_count" class="card-needs mb-5">
        <header class="card-needs__header">
            <h3 class="heading3 heading3--match">Recommended Solutions</h3>
        </header>

        <div class="card-needs__content">
            <div class="row">
                <div v-if="need.recommended_startups_ai_count" class="col-12 col-md-6 mb-2">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active card-needs__notification--ai" :title="need.recommended_startups_ai_count">
                                <img :src="require('@/images/icon-gen-ai.svg')" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">{{need.recommended_startups_ai_count}} new AI {{getNoun('recommendation')}}</div>
                            </div>
                        </div>

                        <footer class="card-headline__footer">
                            <a @click="evaluate('ai')" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>

                <div v-if="need.recommended_startups_eco_count" class="col-12 col-md-6 mb-2">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active" :title="need.recommended_startups_eco_count">
                                <!-- Show ecosystem logo when available, otherwise show default ecosystem icon -->
                                <img v-if="need.recommended_ecosystem" :src="getEcoLogo(need.recommended_ecosystem.logo)" alt="" />
                                <img v-else :src="getEcoLogo(null)" class="mt-3" height="50" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">
                                    <template v-if="need.recommended_ecosystem">
                                        {{need.recommended_ecosystem.name}} sent {{getNumberWithNoun('solution', need.recommended_startups_eco_count)}}
                                    </template>
                                    <template v-else>
                                        {{need.recommended_startups_eco_count}} network {{getNoun('recommendation')}}
                                    </template>
                                </div>
                            </div>
                        </div>
                        <footer class="card-headline__footer">
                            <a @click="evaluate('eco')" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

        <MatchMakingModal
            source="ai"
            ref="aiMatchMakingModal"
            @updated="getInfo"
        />

        <MatchMakingModal
            source="ecosystem"
            ref="ecoMatchMakingModal"
            @updated="getInfo"
        />
    </div>
</template>
